module.exports = __webpack_public_path__ + "media/img/private-venue/unique-1231519c2159560a02acb06786951c82.svg";